module.exports = __webpack_public_path__ + "img/logo_2.d453bb98.png";